import { useMemo } from 'react';
import { FilterSelect } from '@wundo/ui';
import { DEFAULT_DATE_RANGE_OPTIONS, type DateRangeOption } from './dateRangeOptions.ts';

export interface DateRangeFilterProps {
  value: string;
  onChange: (value: string) => void;
  options?: readonly DateRangeOption[];
  /** Names the filter for screen readers; the pill shows only the period. */
  label?: string;
}

/**
 * How far back a list reaches, as a toolbar filter.
 *
 * It picks a preset and nothing else: what "last 30 days" means as a timestamp
 * is the caller's business, because the pages that ask disagree — one counts
 * back from midnight UTC, another from this minute — and a shared answer would
 * quietly change what one of them lists.
 */
export function DateRangeFilter({
  value,
  onChange,
  options = DEFAULT_DATE_RANGE_OPTIONS,
  label = 'Period',
}: DateRangeFilterProps) {
  const choices = useMemo(
    () => options.map((option) => ({ value: option.value, label: option.label })),
    [options],
  );

  return (
    <FilterSelect
      hideLabel
      label={label}
      options={choices}
      value={value}
      onValueChange={onChange}
    />
  );
}
